const MyUnitLocations = ({date_sent,month_on_focus,amount_alloted,unit_name,total_month_income,username,onChecked}) => {
    const monthColors={
        "January": "#075E54",
        "December": "#0251EB",
        "February": "#ff4500",
        "March": "#FF3700B3",
        "April": "#6B014D",
        "May": "#1a1a1a",
        "June": "#29335c",
        "July": "#34B7F1",
        "August": "#25D366",
        "September": "#011F36",
        "October": "#696969",
        "November": "#000000"
    };

    const handleMonthAlloc=(e)=>{
        onChecked(month_on_focus,amount_alloted,e.target.checked,unit_name)
    };

    return ( 
        <div className="myunitalloc flex-column2" key={date_sent} style={{backgroundColor:monthColors[month_on_focus]}}>
            <h3>{unit_name}</h3>
          
            <h4>{`${month_on_focus} (Income): ${total_month_income}`}</h4>
            <h4>
                {`Amount allocated: ${parseFloat(amount_alloted).toLocaleString('en-US',{style:'currency',currency:'GHS'})}`}
            </h4>

            <div style={{width:"100%",border:"1px solid white"}}></div>
            <h3>Remitted by: {username}</h3>
            <h4>Remitted on: {date_sent}</h4>
         
            <div className="collatecheckbox2">
            <input type="checkbox" onChange={handleMonthAlloc}/>
            </div>
        </div>
     );
}
 
export default MyUnitLocations;